import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface PlanTerminationPayload {
  plan_id: string;
  termination_date: string;
  coverage_end_date?: string;
  claim_last_date?: string;
  hsa_transfer_of_assets?: string;
}

export const useTerminatePlanQuery = () => {
  const {
    mutateAsync: createAsync,
    isLoading: createLoading,
    isSuccess: createSuccess,
  } = useMutation((data: PlanTerminationPayload) => api.post(API_URL.PLANS_TERMINATION_PROPERTIES, data));

  const {
    mutateAsync: updateAsync,
    isLoading: updateLoading,
    isSuccess: updateSuccess,
  } = useMutation((data: PlanTerminationPayload) =>
    api.patch(API_URL.PLANS_TERMINATION_PROPERTIES_BY_PLAN_ID(data.plan_id), {
      termination_date: data.termination_date,
      coverage_end_date: data.coverage_end_date,
      claim_last_date: data.claim_last_date,
      hsa_transfer_of_assets: data.hsa_transfer_of_assets,
    })
  );

  return {
    terminatePlan: createAsync,
    isLoading: createLoading,
    isSuccess: createSuccess,
    updatePlan: updateAsync,
    isUpdateLoading: updateLoading,
    isUpdateSuccess: updateSuccess,
  };
};
